import { BookingMaskContainer } from '../../../../components/containers/VerticalBookingContainer/BookingMaskContainer';
import preloadCustomProps from '../../../utils/preloads/preloadStaticContainerProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'verticals-booking',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: BookingMaskContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
